
<template>
    <div>
        <!-- header-bg - width:100% -->
        <div class="w-100">
            <img style="width: 100%;" src="@/assets/imgs/advice/banner02.png">
        </div>
        <div class="g-width breadbox">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{breadText}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="g-width">
            <el-form ref="form" :model="formData" label-width="100px" style="width: fit-content;margin:77px auto 97px"
                :rules="rules">
                <el-form-item label="联系人：" prop="name">
                    <el-input maxLength="20" v-model="formData.name" style="width: 560px;" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系电话：" prop="phone">
                    <el-input v-model="formData.phone" style="width: 560px;" placeholder="请输入联系人电话号码"></el-input>
                </el-form-item>
                <el-form-item label="留言标题：" prop="title">
                    <el-input maxLength="20" v-model="formData.title" style="width: 560px;" placeholder="请输入留言标题"></el-input>
                </el-form-item>
                <el-form-item label="留言内容：" prop="content">
                    <el-input maxLength="300" type="textarea" :rows="4" v-model="formData.content" style="width: 560px;"
                        placeholder="请输入留言内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleConfirm"
                        style="width: 140px;background-color: rgba(48, 136, 233, 1);">提交咨询</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { Message } from "element-ui";
export default {
    data() {
        return {
            formData: {
                name: '',
                phone: '',
                title: '',
                content: ''
            },
            rules: {
                name: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
                phone: [{ required: true, message: '请输入联系人电话号码', trigger: 'blur' }],
                title: [{ required: true, message: '请输入留言标题', trigger: 'blur' }],
                content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
            }
        }
    },
    computed:{
        breadText(){
            const type = this.$route.query.type;
            if(type==1){
                return '我要咨询'
            }else if(type==2){
                return '投诉举报'
            }else if(type==3){
                return '我要建议'
            }else{
                return '联系我们'
            }
        }
    },
    methods: {
        handleConfirm() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.$post('/messageBoard/addMessageBoard',{
                        "contacts": this.formData.name,
                        "content": this.formData.content,
                        "phone": this.formData.phone,
                        "title": this.formData.title
                    },false).then(res=>{
                        if(res.status==='200'){
                            Message({message:'提交成功',type:'success'})
                            this.formData={
                                name: '',
                                phone: '',
                                title: '',
                                content: ''
                            }
                        }
                    })
                }
            })
        }
    }
}


</script>
<style scoped></style>